import { Outlet, useParams, Link } from "react-router-dom";
import productsData from "../data/productsData";
import styles from "./product.module.css";

// 1. Import the images directly from your assets
import edgeAiImage from "../Assets/CTX.png";
import pllImage from "../Assets/PLL.png";
import adcImage from "../Assets/ADC.png";


// --- Data Enhancement ---
// This object now uses the imported images instead of URL strings
const itemDetails = {
    "ctx-edge-ai-processor": {
        image: edgeAiImage,
        description: "A high-performance processor optimized for real-time AI inference at the Edge."
    },
    "phase-locked-loop": {
        image: pllImage,
        description: "A precision Phase-Locked Loop IP for stable and low-jitter clock synthesis."
    },
    "adc": {
        image: adcImage,
        description: "A high-speed, low-power Analog-to-Digital Converter for advanced signal processing."
    }
};
// --- End Data Enhancement ---


export function ProductDetail() {
    const { productId } = useParams();
    const product = productsData.find((p) => p.id === productId);

    if (!product) {
        return (
            <div className={styles.notFound}>
                <h3>Please select a product category to see the details.</h3>
            </div>
        );
    }


    return (
        <div className={styles.detailContainer}>
            <h2 className={styles.detailTitle}>{product.name}</h2>
            
            {/* The rest of the component remains the same */}
            <div className={styles.itemGrid}>
                {product.items.map((item) => {
                    const details = itemDetails[item.id] || {};
                    return (
                        <div key={item.id} className={styles.itemCard}>
                            <img src={details.image} alt={item.name} className={styles.itemImage} />
                            <div className={styles.itemContent}>
                                <h3 className={styles.itemName}>{item.name}</h3>
                                <p className={styles.itemDescription}>{details.description}</p>
                                <Link to={item.id} className={styles.itemLink}>View Details</Link>
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className={styles.itemDetailOutlet}>
                <Outlet />
            </div>
        </div>
    );
}

